import React from 'react';

const Button = ({ children, onClick, variant = 'primary', className = '', disabled = false, type = 'button' }) => {
  const base = 'inline-flex items-center justify-center font-semibold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-amber-700 hover:bg-amber-800 text-white px-6 py-3 focus:ring-amber-500 disabled:opacity-50',
    secondary: 'bg-amber-100 hover:bg-amber-200 text-amber-900 px-6 py-3 focus:ring-amber-400',
    outline: 'border-2 border-amber-700 text-amber-700 hover:bg-amber-700 hover:text-white px-6 py-3 focus:ring-amber-500',
    danger: 'bg-red-600 hover:bg-red-700 text-white px-4 py-2 focus:ring-red-500',
    small: 'bg-amber-700 hover:bg-amber-800 text-white px-4 py-2 text-sm focus:ring-amber-500',
  };
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${base} ${variants[variant] || variants.primary} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
